import { Formik } from 'formik';
import React, { FunctionComponent, ReactNode, useCallback } from 'react';
import { createKeycloakUser, ToastError, ToastSuccess } from 'utils';
import { AuthUserFormFields } from './auth-user-form-field.type';
import accountFormValidationSchema from './auth-user-form-validation-schema';

interface AuthUserFormCreateProps {
  children?: ReactNode;
  onUserCreated?: (userId: string) => void;
}

const AuthUserFormCreate: FunctionComponent<AuthUserFormCreateProps> = ({
  onUserCreated,
  children,
}) => {
  const onSubmit = useCallback(
    async (values: AuthUserFormFields) => {
      const { id } = await createKeycloakUser({
        email: values.email,
        groups: ['/pro-people/pros'],
      }).catch((error) => {
        ToastError(
          'Erreur',
          "Une erreur est survenue lors de la création de l'adresse email",
        );
        throw error;
      });

      ToastSuccess('Succès', 'Adresse email créée');
      onUserCreated?.(id);
    },
    [onUserCreated],
  );

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={{ email: '' }}
      validationSchema={accountFormValidationSchema()}
    >
      {children}
    </Formik>
  );
};

export default AuthUserFormCreate;
